import React from 'react';
import PropTypes from 'prop-types';

import PostActivity from './PostActivity';
import TableOfContents from './TableOfContents';
import ShareThisPost from './ShareThisPost';

/**
 * LeftSidebar - Renders the left sidebar containing:
 * - Post activity metrics
 * - Table of contents
 * - Share buttons
 *
 * @param {Object} props - Component props
 * @returns {JSX.Element}
 */
const LeftSidebar = React.memo(({
    id,
    liked,
    views,
    reading_time: readingTime,
    comment,
    title
}) => {
    return (
        <aside className="sidebar left-sidebar">
            <PostActivity
                key={id}
                liked={liked}
                views={views}
                reading_time={readingTime}
                comment={comment}
            />
            <TableOfContents containerSelector=".post-content" />
            <ShareThisPost title={title} />
        </aside>
    );
});

LeftSidebar.displayName = 'LeftSidebar';

LeftSidebar.propTypes = {
    id: PropTypes.number.isRequired,
    liked: PropTypes.number,
    views: PropTypes.string,
    reading_time: PropTypes.string,
    comment: PropTypes.number,
    title: PropTypes.string.isRequired,
};

LeftSidebar.defaultProps = {
    liked: false,
    views: 0,
    reading_time: '0 min',
    comment: 0,
};

export default LeftSidebar;
